module.exports = __webpack_public_path__ + "img/album21_14.225627b4.jpg";